import clsx from 'clsx';
import { Icon } from 'components/Icon/Icon';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './ConsumptionsActions.module.scss';

type MemberConsumptionsActionsProps = {
    onDeduct: () => void;
    onEdit: () => void;
    onDelete?: () => void;
    transaction: any;
    user: any;
};
export const MemberConsumptionsActions: React.FC<MemberConsumptionsActionsProps> = ({
    onDeduct,
    onEdit,
    onDelete,
    transaction,
    user,
}) => {
    const [isActive, setIsActive] = useState(false);
    const menu = useRef<any>(null);
    const { t } = useTranslation('documents');

    const handleClickOutside = (event: any) => {
        if (menu.current && !menu.current.contains(event.target)) {
            setIsActive(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);

        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);

    return (
        <>
            <div
                className={clsx(styles.actions, isActive && styles.active)}
                onClick={() => setIsActive(!isActive)}
                ref={menu}
            >
                <div className={styles.trigger}>
                    <Icon name="three-dots" />
                </div>
                <div className={styles.dropdown}>
                    <div className={styles.dropdownContent}>
                        {/* {transaction.deductedFrom === 'REGULAR' && user.remainderBalance > 0 && (
                            <div className={styles.dropdownItem} onClick={onDeduct}>
                                <Icon name="change" /> {t('deductFromRemainderButton')}
                            </div>
                        )} */}
                        <div className={styles.dropdownItem} onClick={onEdit}>
                            <Icon name="edit" /> {t('editTransactionButton')}
                        </div>
                        <div className={styles.dropdownItem} onClick={onDelete}>
                            <Icon name="trash" /> {t('deleteTransactionButton')}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
